/*
* This function is used to prevent trigger resize events that are fired when the window resizes vertical
* For example: on iOS Safari, the resize event is triggered when the location bar is shrinked
* Usage: $(window).on('customresize', function(evt) {});
*/

(function($){
  
  var lastWidth = window.innerWidth, currentWidth;

  $(window).on('resize', checkResize);

  function checkResize(evt) {
    currentWidth = window.innerWidth;
    if(currentWidth != lastWidth) {
      $(window).trigger('customresize', [evt]);
    }
  }

})(jQuery);